// Import styling.
import './assets/main.scss'

// Import Bootstrap functionality.
import './bootstrap'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { QueryClient, QueryObserver, VueQueryPlugin } from "@tanstack/vue-query";

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  // TODO Configure Faro integration.
  console.error('App instrumentation not yet configured, but received unhandled error.', { error: err, instance, info })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    }
  }
})

if (import.meta.env.DEV) {
  const queryObserver = new QueryObserver(
    queryClient,
    { queryKey: [] }
  )

  queryObserver.subscribe(
    (query) => {
      if (query.isError) {
        console.error('Encountered query error', { error: query.error, json: `(${JSON.stringify(query.error)})`, query })
      }
    }
  )
}

app.provide('queryClient', queryClient)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, { queryClient })

app.mount('#app')
